import React, { useEffect, useState } from "react";
import { env } from "../../constants/env";
import CalendarIcon from "../../icon/CalendarIcon";
import DownArrowIcon from "../../icon/DownArrowIcon";
import JusticeScaleIcon from "../../icon/JusticeScaleIcon";
import StarIcon from "../../icon/StarIcon";
import CommonButton from "../../ui/CommonButton";
import classes from "./ChallengeSteps.module.css";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../hooks/getWindowDimensions";

const token = localStorage.getItem("userToken");

const ChallengeSteps = ({ startButton, className, setShowPurchase, activeAccountType, setActiveAccountType, setAccountTypeAmount  }) => {
  const { width } = useWindowDimensions();
  const [isSending, setIsSending] = useState();
  const { setUser } = useUser();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [tooltipOpenIndex, setTooltipOpenIndex] = useState(null);
  const [expandedSection, setExpandedSection] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(width <= 768);
  }, [width]);

  const handlePurchase = async () => {
    setIsSending(true);
    setMessage("");

    const purchaseData = {
      amountRequired: 1,
      activeAccountType,
      currencyId: "USDT",
    };

    try {
      const response = await axios.post(
        `${env.apiUrl}/api/purchase`,
        purchaseData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Purchase Response:", response.data);

      const { paymentLink } = response.data;

      if (paymentLink) {
        // Open the payment link in a new tab
        window.open(paymentLink, "_self", "noopener,noreferrer");
        setMessage("Redirecting to payment...");
      } else {
        setMessage("Payment link not found.");
      }
    } catch (error) {
      console.error(
        "Purchase Error:",
        error.response ? error.response.data : error.message
      );
      const err = error.response
        ? error.response.data.error
        : "Failed to process purchase.";
      setMessage(err);
    } finally {
      setIsSending(false);
    }
  };

  const accountValues = {
    "10K": {
      profitTargetStep1: "$800",
      profitTargetStep2: "$400",
      profitTargetStep3: "X",
      dailyLossStep1: "$400",
      dailyLossStep2: "$400",
      dailyLossStep3: "$400",
      maxLossStep1: "$800",
      maxLossStep2: "$800",
      maxLossStep3: "$800",
      tradingPeriodStep1: "Unlimited",
      tradingPeriodStep2: "Unlimited",
      tradingPeriodStep3: "Unlimited",
      minTradingDaysStep1: "5 Days",
      minTradingDaysStep2: "5 Days",
      minTradingDaysStep3: "X",
      tradingLeverageStep1: "1:50",
      tradingLeverageStep2: "1:50",
      tradingLeverageStep3: "1:25",
      payoutFrequencyStep1: "X",
      payoutFrequencyStep2: "X",
      payoutFrequencyStep3: "Every 14 Days (First After 30-Day Hold)",
      regFee: "$100.00",
      regFeeButton: "$100",
    },
    "25K": {
      profitTargetStep1: "$2000",
      profitTargetStep2: "$1000",
      profitTargetStep3: "X",
      dailyLossStep1: "$1000",
      dailyLossStep2: "$1000",
      dailyLossStep3: "$1000",
      maxLossStep1: "$2000",
      maxLossStep2: "$2000",
      maxLossStep3: "$2000",
      tradingPeriodStep1: "Unlimited",
      tradingPeriodStep2: "Unlimited",
      tradingPeriodStep3: "Unlimited",
      minTradingDaysStep1: "5 Days",
      minTradingDaysStep2: "5 Days",
      minTradingDaysStep3: "X",
      tradingLeverageStep1: "1:50",
      tradingLeverageStep2: "1:50",
      tradingLeverageStep3: "1:25",
      payoutFrequencyStep1: "X",
      payoutFrequencyStep2: "X",
      payoutFrequencyStep3: "Every 14 Days (First After 30-Day Hold)",
      regFee: "$200.00",
      regFeeButton: "$200",
    },
    "50K": {
      profitTargetStep1: "$4000",
      profitTargetStep2: "$2000",
      profitTargetStep3: "X",
      dailyLossStep1: "$2000",
      dailyLossStep2: "$2000",
      dailyLossStep3: "$2000",
      maxLossStep1: "$4000",
      maxLossStep2: "$4000",
      maxLossStep3: "$4000",
      tradingPeriodStep1: "Unlimited",
      tradingPeriodStep2: "Unlimited",
      tradingPeriodStep3: "Unlimited",
      minTradingDaysStep1: "5 Days",
      minTradingDaysStep2: "5 Days",
      minTradingDaysStep3: "X",
      tradingLeverageStep1: "1:50",
      tradingLeverageStep2: "1:50",
      tradingLeverageStep3: "1:25",
      payoutFrequencyStep1: "X",
      payoutFrequencyStep2: "X",
      payoutFrequencyStep3: "Every 14 Days (First After 30-Day Hold)",
      regFee: "$350.00",
      regFeeButton: "$350",
    },
    "100K": {
      profitTargetStep1: "$8000",
      profitTargetStep2: "$4000",
      profitTargetStep3: "X",
      dailyLossStep1: "$4000",
      dailyLossStep2: "$4000",
      dailyLossStep3: "$4000",
      maxLossStep1: "$8000",
      maxLossStep2: "$8000",
      maxLossStep3: "$8000",
      tradingPeriodStep1: "Unlimited",
      tradingPeriodStep2: "Unlimited",
      tradingPeriodStep3: "Unlimited",
      minTradingDaysStep1: "5 Days",
      minTradingDaysStep2: "5 Days",
      minTradingDaysStep3: "X",
      tradingLeverageStep1: "1:50",
      tradingLeverageStep2: "1:50",
      tradingLeverageStep3: "1:25",
      payoutFrequencyStep1: "X",
      payoutFrequencyStep2: "X",
      payoutFrequencyStep3: "Every 14 Days (First After 30-Day Hold)",
      regFee: "$500.00",
      regFeeButton: "$500",
    },
  };

  const tableData = [
    {
      name: "Profit Target",
      step1: accountValues[activeAccountType].profitTargetStep1,
      step2: accountValues[activeAccountType].profitTargetStep2,
      step3: accountValues[activeAccountType].profitTargetStep3,
      icon: "star",
      tip: "The profit you need to make as a result of your closed positions.",
    },
    {
      name: "Daily Loss",
      step1: accountValues[activeAccountType].dailyLossStep1,
      step2: accountValues[activeAccountType].dailyLossStep2,
      step3: accountValues[activeAccountType].dailyLossStep3,
      icon: "arrow",
      tip: "This value represents the lowest equity drop recorded in a single day. The daily loss limit includes both open and closed positions.",
    },
    {
      name: "Maximum Loss",
      step1: accountValues[activeAccountType].maxLossStep1,
      step2: accountValues[activeAccountType].maxLossStep2,
      step3: accountValues[activeAccountType].maxLossStep3,
      icon: "arrow",
      tip: "The lowest equity reached during active trades throughout the evaluation cycle, calculated from the initial account balance.",
    },
    {
      name: "Trading Period",
      step1: accountValues[activeAccountType].tradingPeriodStep1,
      step2: accountValues[activeAccountType].tradingPeriodStep2,
      step3: accountValues[activeAccountType].tradingPeriodStep3,
      icon: "calendar",
      tip: "It defines how long traders have to meet trading objectives within a challenge.",
    },
    {
      name: "Minimum Trading Days",
      step1: accountValues[activeAccountType].minTradingDaysStep1,
      step2: accountValues[activeAccountType].minTradingDaysStep2,
      step3: accountValues[activeAccountType].minTradingDaysStep3,
      icon: "calendar",
      tip: "Traders must open at least one trade on separate days for a minimum of 5 days.",
    },
    {
      name: "Trading Leverage",
      step1: accountValues[activeAccountType].tradingLeverageStep1,
      step2: accountValues[activeAccountType].tradingLeverageStep2,
      step3: accountValues[activeAccountType].tradingLeverageStep3,
      icon: "scale",
      tip: "The ratio of borrowed funds to the trader's own capital, allowing for increased exposure and potential returns.",
    },
    {
      name: "Payout Frequency",
      step1: accountValues[activeAccountType].payoutFrequencyStep1,
      step2: accountValues[activeAccountType].payoutFrequencyStep2,
      step3: accountValues[activeAccountType].payoutFrequencyStep3,
      icon: "calendar",
      tip: "Refers to how often traders receive their earned profits.",
    },
  ];

  const mobileSections = [
    {
      title: "Profit Target",
      icon: "star",
      tip: "The profit you need to make as a result of your closed positions.",
      steps: {
        step1: accountValues[activeAccountType].profitTargetStep1,
        step2: accountValues[activeAccountType].profitTargetStep2,
        step3: accountValues[activeAccountType].profitTargetStep3,
      },
    },
    {
      title: "Daily Loss",
      icon: "arrow",
      tip: "This value represents the lowest equity drop recorded in a single day. The daily loss limit includes both open and closed positions.",
      steps: {
        step1: accountValues[activeAccountType].dailyLossStep1,
        step2: accountValues[activeAccountType].dailyLossStep2,
        step3: accountValues[activeAccountType].dailyLossStep3,
      },
    },
    {
      title: "Maximum Loss",
      icon: "arrow",
      tip: "The lowest equity reached during active trades throughout the evaluation cycle, calculated from the initial account balance.",
      steps: {
        step1: accountValues[activeAccountType].maxLossStep1,
        step2: accountValues[activeAccountType].maxLossStep2,
        step3: accountValues[activeAccountType].maxLossStep3,
      },
    },
    {
      title: "Trading Period",
      icon: "calendar",
      tip: "It defines how long traders have to meet trading objectives within a challenge.",
      steps: {
        step1: accountValues[activeAccountType].tradingPeriodStep1,
        step2: accountValues[activeAccountType].tradingPeriodStep2,
        step3: accountValues[activeAccountType].tradingPeriodStep3,
      },
    },
    {
      title: "Minimum Trading Days",
      icon: "calendar",
      tip: "Traders must open at least one trade on separate days for a minimum of 5 days.",
      steps: {
        step1: accountValues[activeAccountType].minTradingDaysStep1,
        step2: accountValues[activeAccountType].minTradingDaysStep2,
        step3: accountValues[activeAccountType].minTradingDaysStep3,
      },
    },
    {
      title: "Trading Leverage",
      icon: "scale",
      tip: "The ratio of borrowed funds to the trader's own capital, allowing for increased exposure and potential returns.",
      steps: {
        step1: accountValues[activeAccountType].tradingLeverageStep1,
        step2: accountValues[activeAccountType].tradingLeverageStep2,
        step3: accountValues[activeAccountType].tradingLeverageStep3,
      },
    },
    {
      title: "Payout Frequency",
      icon: "calendar",
      tip: "Refers to how often traders receive their earned profits.",
      steps: {
        step1: accountValues[activeAccountType].payoutFrequencyStep1,
        step2: accountValues[activeAccountType].payoutFrequencyStep2,
        step3: accountValues[activeAccountType].payoutFrequencyStep3,
      },
    },
  ];

  const toggleMobileSection = (index) => {
    setExpandedSection(expandedSection === index ? null : index);
  };

  const renderMobileView = () => (
    <div className={classes.mobileContainer}>
      <div className={`${classes.mobileAccountSizeSection} ${startButton ? "" : "border-top-0"}`}>
        <h5>Available Account Size</h5>
        <div className={classes.mobileAccountOptions}>
          {["10K", "25K", "50K", "100K"].map((size) => (
            <h2
              key={size}
              className={`${classes.mobileAccountOption} ${
                activeAccountType === size ? classes.mobileActiveAccount : ""
              }`}
              onClick={() => setActiveAccountType(size)}
            >
              ${size}
            </h2>
          ))}
        </div>
      </div>

      <div className={classes.mobilePlatformInfo}>
        <div className={classes.mobileMt5Badge}>
          <img src="/images/mt-5-icon.png" alt="MT5 Platform" />
          <span>MT5 platform</span>
        </div>
        <p className={classes.mobileCommissionInfo}>
          Enjoy $0 commission and swap fees. Keep 100% of profits
        </p>
      </div>

      <div className={classes.mobileObjectivesList}>
        {mobileSections.map((section, index) => (
          <div key={index} className={classes.mobileObjectiveItem}>
            <div
              className={`${classes.mobileObjectiveHeader} d-flex align-items-center gap-2`}
              onClick={() => toggleMobileSection(index)}
            >
              {section.icon === "star" ? (
                <StarIcon />
              ) : section.icon === "arrow" ? (
                <DownArrowIcon />
              ) : section.icon === "calendar" ? (
                <CalendarIcon />
              ) : (
                <JusticeScaleIcon />
              )}
              <h3>{section.title}</h3>
              {expandedSection === index ? <IoChevronUp /> : <IoChevronDown />}
            </div>
            {expandedSection === index && (
              <p className={classes.tipText}>{section.tip}</p>
            )}

            {/* {expandedSection === index && ( */}
            <div className={classes.mobileObjectiveDetails}>
              {section.steps.step1 && section.steps.step1 !== "X" && (
                <div className={`d-flex align-items-center gap-2`}>
                  <span
                    className={`${classes.mobileStepTitle} d-flex align-items-center w-50`}
                  >
                    Step 1: Trading Challenge
                  </span>
                  <span
                    className={`${classes.mobileStepValue} d-flex align-items-center w-50`}
                  >
                    {section.steps.step1}
                  </span>
                </div>
              )}
              {section.steps.step2 && section.steps.step2 !== "X" && (
                <div className={`d-flex align-items-center gap-2`}>
                  <span
                    className={`${classes.mobileStepTitle} d-flex align-items-center w-50`}
                  >
                    Step 2: Verification
                  </span>
                  <span
                    className={`${classes.mobileStepValue} d-flex align-items-center w-50`}
                  >
                    {section.steps.step2}
                  </span>
                </div>
              )}
              {section.steps.step3 && section.steps.step3 !== "X" && (
                <div className={`d-flex align-items-center gap-2`}>
                  <span
                    className={`${classes.mobileStepTitle} d-flex align-items-center w-50`}
                  >
                    Step 3: Live Simulated Trader
                  </span>
                  <span
                    className={`${classes.mobileStepValue} d-flex align-items-center w-50`}
                  >
                    {section.steps.step3}
                  </span>
                </div>
              )}
            </div>
            {/* )} */}
          </div>
        ))}
      </div>

      <div className={classes.mobileRegistrationFee}>
        {startButton && <h2 className="text-center">
          {accountValues[activeAccountType].regFee} Registration Fee
        </h2>}
      </div>

      <div
        className={`d-flex justify-content-center ${classes.mobileButtonContainer}`}
      >
        <CommonButton
          text="Purchase"
          className={classes.mobileStartButton}
          onClick={() => { setAccountTypeAmount(accountValues[activeAccountType].regFee); setShowPurchase(true);}}
        />
      </div>
    </div>
  );

  const renderDesktopView = () => (
    <div
      className={`row d-flex justify-content-center ${classes.wrapper} ${className}`}
    >
      <div className={classes.card}>
        {/* Desktop card top section */}
        <div className={classes.cardTopSection}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5>Available Account size</h5>
              <div className="d-flex align-items-center gap-4">
                {["10K", "25K", "50K", "100K"].map((size) => (
                  <h2
                    key={size}
                    role="button"
                    onClick={() => setActiveAccountType(size)}
                    className={`${classes.accountType} ${
                      activeAccountType === size
                        ? classes.activeAccountType
                        : ""
                    }`}
                  >
                    ${size}
                  </h2>
                ))}
                <div className={classes.tag}>
                  Enjoy $0 commission and swap fees. Keep 100% of profits
                </div>
              </div>
            </div>
            <div
              className={`${classes.mt5Container} d-flex align-items-center gap-2`}
            >
              <img src="/images/mt-5-icon.png" alt="MT5 Platform" />
              <div>MT5 platform</div>
            </div>
          </div>
        </div>

        {/* Desktop table */}
        <div className={classes.tableContainer}>
          <div className={classes.tableGrid}>
            <div className={classes.tableHeaderCell}></div>
            <div className={classes.tableHeaderCell}>
              <h3>Step 1: Trading Challenge</h3>
            </div>
            <div className={classes.tableHeaderCell}>
              <h3>Step 2: Verification</h3>
            </div>
            <div className={classes.tableHeaderCell}>
              <h3>Step 3: Live Simulated Trader</h3>
            </div>

            {tableData.map((row, index) => (
              <React.Fragment key={index}>
                <div
                  className={`${classes.tableCell} d-flex flex-column justify-content-center align-items-start gap-2`}
                >
                  <div
                    className={`d-flex align-items-center gap-2 ${classes.iconTextContainer}`}
                    onClick={() =>
                      setTooltipOpenIndex(
                        tooltipOpenIndex === index ? null : index
                      )
                    }
                    role="button"
                  >
                    {row.icon === "star" ? (
                      <StarIcon />
                    ) : row.icon === "arrow" ? (
                      <DownArrowIcon />
                    ) : row.icon === "calendar" ? (
                      <CalendarIcon />
                    ) : (
                      <JusticeScaleIcon />
                    )}
                    <div>{row.name}</div>
                    {tooltipOpenIndex === index ? (
                      <IoChevronUp />
                    ) : (
                      <IoChevronDown />
                    )}
                  </div>
                  {tooltipOpenIndex === index && (
                    <div className={classes.tooltipContainer}>
                      <span className={classes.tooltipText}>{row.tip}</span>
                    </div>
                  )}
                </div>

                <div className={classes.tableCell}>
                  <div className={classes.amountContainer}>{row.step1}</div>
                </div>

                <div className={classes.tableCell}>
                  <div className={classes.amountContainer}>{row.step2}</div>
                </div>

                <div className={classes.tableCell}>
                  <div className={classes.amountContainer}>{row.step3}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className={classes.tableFooter}>
          {startButton ? (<h2 className="text-center ">
            {accountValues[activeAccountType].regFee} registration fee
          </h2>) : 
          (<div
            className={`${classes.bottomButton} d-flex  justify-content-center `}
          >
            <CommonButton
              text={
                accountValues[activeAccountType].regFeeButton +
                " Registration fee"
              }
              className={classes.buttonText}
              onClick={() => {setAccountTypeAmount(accountValues[activeAccountType].regFee); setShowPurchase(true);}}
            />
          </div>)}
        </div>
      </div>

      {startButton && (
        <div
          className={`${classes.bottomButton} my-4 d-flex flex-column align-items-center`}
        >
          <CommonButton
            text="Purchase"
            className={classes.buttonText}
            onClick={() => {setAccountTypeAmount(accountValues[activeAccountType].regFee); setShowPurchase(true);}}
          />

          <p className="mt-3">
            By starting a challenge you agree to our <span>TOS</span> and{" "}
            <a href={`${env.siteUrl}/terms`}>refund policy.</a>
          </p>
        </div>
      )}
    </div>
  );
  return isMobile ? renderMobileView() : renderDesktopView();
};

export default ChallengeSteps;
